import {docReady, loadColors} from "./utils";
import {dropDown} from "./dropDown";
import "@babel/polyfill";
import bars from "./wwwbars";
import * as d3 from "d3";

window.runBars = function (resourceUrl,target = '#calc',options) {
    const colorsRq = loadColors('colors.ddxml');
    const barsRq = fetch(resourceUrl + 'www.jsonv')
        .then(resp => resp.json());
    return Promise.all([barsRq, colorsRq])
        .then(([barsData, colors]) => {
            const total = {
                kicker: barsData.kicker,
                headline: barsData.headline,
                category: barsData.category,
                infoText: barsData.infoText,
                createdTS: barsData.createdTS,
                source: barsData.source,
                values: barsData.total,
            };
            const update = bars(target, colors, total, options);
            let lastTopic = '';
            window.updateData = function (key,topic) {
                const fromZero = lastTopic !== key;
                if(key === 'total'){
                    update(barsData.total, false, barsData.max, fromZero);
                    lastTopic = key;
                    return;
                }
                const topicItem = barsData.topics.find( topicItem => topicItem.title === key);
                const subTopic = topicItem.subTopics.find(subTopic =>subTopic.title === topic);
                update(subTopic.values,false, topicItem.max, fromZero);
                lastTopic = key;
            }
        })
        .catch( e=>{
            const barsRq = fetch('preview_www.jsonv')
                .then(resp => resp.json());
            return Promise.all([barsRq, colorsRq]).then(([barsData, colors])=>{
                const total = {
                    kicker: barsData.kicker,
                    headline: barsData.headline,
                    category: barsData.category,
                    infoText: barsData.infoText,
                    createdTS: barsData.createdTS,
                    source: barsData.source,
                    values: barsData.total,
                };
                options.noBars = true;
                bars(target, colors, total, options);
                d3.selectAll('.percent-group text').remove();
                return true;
            })
        });

    /* const random = d3.randomUniform(41);
     const update = columns();
     dropDown(function (){
         update( [
             {eoName: "soziale Gerechtigkeit", value: random()},
             {eoName: "Wirtschaft/Arbeit", value: random()},
             {eoName: "Flüchtlinge", value: random()},
             {eoName: "Schule/Bildung", value: random()}
         ])
     });*/

};
/*docReady(function () {
    runBars(''); // run with it
});*/
